import React from "react";
import Image from "next/image";

const LeverageMiles: React.FC = () => {
  return (
    <div className="w-full pt-6 pb-12 square_grid_bg">
      <div className="text-center">
        <h2 className="font-bold relative inline-block 2xl:text-[36px] md:text-[24px] md:leading-[42px] leading-[23px] text-[20px] md:text-black text-black text-center md:mb-1">
          <Image
            src="/healthcare/str.png"
            alt="healthcare icon"
            className="w-[18px] absolute top-0 -left-6"
            width={12}
            height={11}
          />

          <span className="border-[#ca7216] border-b-[4px] md:pb-0 md:pt-[2%] pb-[5px] inline-block text-black">
            The US is Facing a Severe Healthcare Talent Crisis
          </span>
        </h2>
      </div>

      <div className=" lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C]  z-[0] relative md:block hidden mt-16">
        <div className="flex justify-start items-center w-full bg-white border-2 border-[#FFA548] rounded-[10px] shadow-lg px-8 py-5 mb-6 mx-auto 2xl:w-[85%] md:w-[90%]">
          <div className="2xl:w-[15%] md:w-[12%]">
            <p className="2xl:text-[30px] md:text-[28px] text-left font-bold leading-[1.3]">
              Nurse <br /> Shortage
            </p>
          </div>
          <div className="w-[2%] md:w-[13%] flex justify-center items-center">
            <Image
              priority
              src="/healthcare/l7.svg"
              alt="desktop-line"
              className="h-[60px] hidden md:block"
              width={1}
              height={90}
            />
          </div>

          <p className="2xl:text-[24px] md:text-[24px] leading-[1.2] 2xl:ml-2 md:ml-1 md:font-semibold">
            As 80% of nurses are set to retire in two decades, the healthcare
            sector must brace for a significant workforce shortage.
          </p>
        </div>

        <div className="flex justify-start items-center w-full bg-white border-2 border-[#FFA548] rounded-lg shadow-lg px-8 py-5 mb-6 mt-12  mx-auto 2xl:w-[85%] md:w-[90%]">
          <div className="2xl:w-[15%] md:w-[12%]">
            <p className=" 2xl:text-[30px] md:text-[28px] font-bold leading-[1.3]">
              Doctor <br /> Shortage
            </p>
          </div>
          <div className="w-[2%] md:w-[13%] flex justify-center items-center">
            <Image
              priority
              src="/healthcare/l7.svg"
              alt="desktop-line"
              className="h-[60px] hidden md:block"
              width={1}
              height={90}
            />
          </div>

          <p className="2xl:text[24px] md:text-[24px] leading-[1.3] 2xl:ml-4 md:ml-2 md:font-semibold">
            The U.S. healthcare system could face a deficit of 48,000 primary
            care doctors and 77,000 specialists by 2034, risking patient care
            delays.
          </p>
        </div>
      </div>
    </div>
  );
};
export default LeverageMiles;
